import { useContext } from 'react';

import {
  LanguageState,
  MessageComposerContext,
  MessageComposerContextState,
  MessageComposerDispatchContext,
} from './message-composer-state';

export const useMessageComposerState = () => useContext(MessageComposerContext);
export const useMessageComposerDispatch = () => useContext(MessageComposerDispatchContext);

type MessageInputContextState = Omit<MessageComposerContextState, 'languageToState'> &
  LanguageState;
export const useMessageInputState = (): MessageInputContextState => {
  const { languageToState, languageCode, ...rest } = useMessageComposerState();
  return {
    languageCode,
    ...languageToState[languageCode],
    ...rest,
  };
};
